export const PMT = (ir, np, pv) => {
  var pmt, pvif;

  pvif = Math.pow(1 + ir, np);
  pmt = (-ir * (pv * pvif)) / (pvif - 1);
  return Number(pmt);
};
